import { render, staticRenderFns } from "./VDropZone.vue?vue&type=template&id=6aef04b6&scoped=true"
import script from "./VDropZone.vue?vue&type=script&lang=js"
export * from "./VDropZone.vue?vue&type=script&lang=js"
import style0 from "./VDropZone.vue?vue&type=style&index=0&id=6aef04b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aef04b6",
  null
  
)

export default component.exports